import { render, staticRenderFns } from "./create-contract.html?vue&type=template&id=3b570c6a&scoped=true&external"
import script from "./create-contract.js?vue&type=script&lang=js&external"
export * from "./create-contract.js?vue&type=script&lang=js&external"
import style0 from "./create-contract.scss?vue&type=style&index=0&id=3b570c6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b570c6a",
  null
  
)

export default component.exports